module.exports = __webpack_public_path__ + "static/media/cross.33e245eb.png";